module.exports = __webpack_public_path__ + "img/img8.38d91149.jpg";